import { NOT_SELECTED_ERROR } from '../../constants'

const validate = ({ appointmentDate }) => {
  const errors = {}

  if (!(appointmentDate && appointmentDate.time)) {
    errors.appointmentDate = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
